import type { ThemeColorName } from '@examdojo/styles';

/** Default styling for feature lines (neutral dashed) */
export const FEATURE_LINE_DEFAULTS = {
  color: 'neutral' as ThemeColorName,
  strokeWidth: 1,
  dash: 2,
};
